import React, { useState } from 'react';
import './ContactSection.css';
import logo2 from '../assets/logo2.png';
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from 'react-icons/fa';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://driveincarspa.com/submit-contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      const text = await response.text();

      if (response.ok) {
        alert('Form submitted successfully!');
        setFormData({
          name: '',
          phone: '',
          email: '',
          subject: '',
          message: '',
        });
      } else {
        alert('Submission failed. Please try again.');
        console.error(text);
      }
    } catch (err) {
      alert('An error occurred. Please try later.');
      console.error(err);
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-left">
        <div className="contact-form-box">
          <h2 className="contact-form-title">TALK TO US</h2>
          <div className="contact-form-sub">FILL OUT THE FORM AND LET'S BEGIN.</div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              className="contact-input"
              name="name"
              type="text"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              className="contact-input"
              name="phone"
              type="tel"
              placeholder="Phone Number"
              required
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              className="contact-input"
              name="email"
              type="email"
              placeholder="Your email"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <input
              className="contact-input"
              name="subject"
              type="text"
              placeholder="Subject"
              required
              value={formData.subject}
              onChange={handleChange}
            />
            <textarea
              className="contact-input contact-textarea"
              name="message"
              placeholder="Your message (optional)"
              rows={3}
              value={formData.message}
              onChange={handleChange}
            />
            <button className="contact-submit" type="submit">
              SUBMIT
            </button>
          </form>
        </div>
      </div>

      <div className="contact-right">
        <div className="contact-map-wrap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3883.36733223867!2d77.55674497589018!3d13.264970308376897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb1df1166bf4cd5%3A0x7e342fcc2e976626!2sArkiya%20Innovtions%20LLP!5e0!3m2!1sen!2sin!4v1753089094826!5m2!1sen!2sin"
            width="100%"
            height="320"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>

        <div className="contact-info-content">
          <div className="contact-logos">
            <img src={logo2} alt="Logo2" className="contact-logo" />
          </div>

          <div className="contact-info-row">
            <FaMapMarkerAlt size={22} className="contact-info-icon" />
            <span className="contact-info-label">ADDRESS</span>
            <span className="contact-info-text left-info">
              No: 38/A, Doddaballapur Integrated Textile Park Ltd, Sw 51, Apparel Park, Kiadb Industrial Area Phase 2, Doddaballapur, Bengaluru Rural District, Karnataka. Pin Code: 561203
            </span>
          </div>

          <div className="contact-info-row">
            <FaPhoneAlt className="contact-info-icon" />
            <span className="contact-info-label">PHONE</span>
            <span className="contact-info-text">
              +91-8951509309<br />+91-6362465824
            </span>
          </div>

          <div className="contact-info-row">
            <FaEnvelope className="contact-info-icon" />
            <span className="contact-info-label">EMAIL</span>
            <span className="contact-info-text">driveincarspa@gmail.com</span>
          </div>

          <div className="contact-socials">
            <a href="https://www.facebook.com/driveincarspa" className="contact-social" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/driveincarspa" className="contact-social" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.youtube.com/@driveincarspa" className="contact-social" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
